import { IError } from 'types/graphqlTypes'
import { IPriceRequestDetailsFragment } from 'apps/marketplace/pages/spot-quote-tool/graphql/PriceRequestDetailsFragment'
import { useUpdatePriceRequestQuoteMutation } from 'apps/marketplace/pages/spot-quote-tool/graphql/UpdatePriceRequestQuoteMutation'
import { TUpdateQuoteSchema } from '../schema/UpdateQuoteSchema'

interface IUpdateQuoteResult {
  updateQuoteResult: IPriceRequestDetailsFragment
  errors: IError[] | undefined
  loading: boolean
}

export const useUpdateQuote = () => {
  const [updatePriceRequestQuoteMutation, { loading }] = useUpdatePriceRequestQuoteMutation()

  const update = async (formValues: TUpdateQuoteSchema): Promise<IUpdateQuoteResult> => {
    const { data } = await updatePriceRequestQuoteMutation({
      variables: {
        input: { ...formValues },
      },
    })

    const { updatePriceRequestQuote } = data || {}
    const { errors, quotes } = updatePriceRequestQuote || {}
    const updateQuoteResult = quotes as IPriceRequestDetailsFragment

    return {
      updateQuoteResult,
      errors,
      loading,
    }
  }

  return {
    update,
    loading,
  }
}
